import { render, staticRenderFns } from "./asset-history-popup-details.vue?vue&type=template&id=6c04e8fe&scoped=true&"
import script from "./js/asset-history-popup-details.js?vue&type=script&lang=js&"
export * from "./js/asset-history-popup-details.js?vue&type=script&lang=js&"
import style0 from "./asset-history-popup-details.vue?vue&type=style&index=0&id=6c04e8fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c04e8fe",
  null
  
)

export default component.exports